import styled from 'styled-components';

export const CardGridComponent = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
